export function formatCurrency(amount: number, region: string, short?: boolean): string {
    const locale = region == 'NZ' ? 'en-NZ' : 'en-AU';
    const currency = region == 'NZ' ? 'NZD' : 'AUD';
    if (short) {
        let shortAmount: string;
        if (amount >= 1000000) {
            shortAmount = (amount / 1000000).toFixed(amount % 1000000 === 0 ? 0 : 1) + 'm';
        } else if (amount >= 1000) {
            shortAmount = (amount / 1000).toFixed(amount % 1000 === 0 ? 0 : 1) + 'k';
        } else {
            shortAmount = amount.toString();
        }
        // Get the currency symbol only
        const symbol =
            new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            })
                .formatToParts(0)
                .find((part) => part.type === 'currency')?.value || '';
        return `${symbol}${shortAmount}`;
    }
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
    }).format(amount);
}
